import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_PsychologicalCounseling_CaseStatusList({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const formatDetail = (data) => {
      if (!data) return;

      data.sort(function (pre, next) {
        return new Date(next["諮商日期"]) - new Date(pre["諮商日期"]);
      });

      let groups = {};
      data.forEach((item) => {
        item["開案日期"] = item["開案日期"]
          ? moment(item["開案日期"]).format("YYYY-MM-DD")
          : "-";

        if (!groups[item["個案ID"]]) groups[item["個案ID"]] = [];
        groups[item["個案ID"]].push(item);
      });

      return Object.values(groups).map((item) => {
        const last1Data = item[0],
          last2Data = item.length > 1 ? item[1] : null,
          last3Data = item.length > 2 ? item[2] : null;
        return {
          ...last1Data,
          "L1-BSR-5": last1Data["BSR-5"],
          "L1-自殺": last1Data["自殺"],
          "L1-GDS-15": last1Data["GDS-15"],
          "L2-BSR-5": last2Data ? last2Data["BSR-5"] : null,
          "L2-自殺": last2Data ? last2Data["自殺"] : null,
          "L2-GDS-15": last2Data ? last2Data["GDS-15"] : null,
          "L3-BSR-5": last3Data ? last3Data["BSR-5"] : null,
          "L3-自殺": last3Data ? last3Data["自殺"] : null,
          "L3-GDS-15": last3Data ? last3Data["GDS-15"] : null,
        };
      });
    };

    const formatData = formatDetail(apiData);

    setTbData({
      raw: formatData,
      format: null,
      export: formatData,
      totalRecord: formatData.length,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isLazy: true,
        isPaginator: true,
        callMainAPI: null,
      })}
    </>
  );
}
